import "angular";
import DocsController from "./DocsController";
import DocsStates from "./DocsStates";
import DocsLinksService from "./DocsLinksService";

const DocsModule = angular
    .module("DocsModule", ["ui.router"])
    .controller("DocsController", DocsController)
    .service("DocsLinksService", DocsLinksService)
    .config(DocsStates);
export default DocsModule;
